export default "__VITE_ASSET__CANGNTFZ__"